export default "__VITE_ASSET__Chh5fToj__"